import { common } from './common.icons';

export const IconGrid1 = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-grid1 ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <rect x="1.25" y="1.25" width="13.5" height="13.5" fill="" />
      <rect x="1.25" y="1.25" width="13.5" height="13.5" stroke="none" strokeWidth="0.7875" />
    </svg>
  );
};
